const baseUrl = process.env.REACT_APP_BASE_URL || "develop--dreame-api.warrantyservices.com.au";
const country = process.env.REACT_APP_COUNTRY || "AU";
const customerBaseUrl = process.env.REACT_APP_CUSTOMER_BASE_URL || "";
const countryBrandId = process.env.REACT_APP_COUNTRY_BRAND_ID || "";
const brandCode = process.env.REACT_APP_BRAND_CODE || "DREAME";
const customerUrl =  process.env.REACT_APP_URL_CUSTOMER;

const apiUrl = `https://${baseUrl}/api/`;
const config = {
  backendServer: apiUrl,
  country: country,
  baseUrl: baseUrl,
  customerBaseUrl,
  countryBrandId, 
  brandCode,
  customerUrl
};

export default config;
